import $ from 'jquery';

const Filter = function () {
  this.opts = {
    filterButtons: false,
    listItems: false,
    reduceItems: false,
    showAllButton: false,
  };

  this.init = function (el, opts) {
    this.el = el;
    this.opts = $.extend(this.opts, opts);
    this.opts.filterButtons = this.el.find('.filter-button');
    this.setup();

    return this;
  };
};

Filter.fn = Filter.prototype;

Filter.fn.setEvents = function () {
  this.opts.filterButtons.on('click', e => {
    const $this = $(e.target);
    const filterType = $this.attr('data-filter');
    const clicked = $this.hasClass('active');

    if (!clicked) {
      this.opts.filterButtons.removeClass('active');
      $this.addClass('active');
      this.filterItems(filterType);
    } else {
      $this.removeClass('active');
      this.filterItems(0);
    }
  });

  if (this.opts.showAllButton) {
    this.opts.showAllButton.on('click', () => {
      this.filterItems(0);
      this.opts.filterButtons.removeClass('active');
    });
  }
};

Filter.fn.filterItems = function (filterType) {
  if (this.opts.reduceItems) {
    this.opts.listItems
      .hide()
      .filter(function () {
        return filterType === 0 ? true : $(this).attr('data-filter').includes(filterType);
      })
      .show();
  } else {
    this.opts.listItems
      .addClass('listing__item--non-active')
      .filter(function () {
        return filterType === 0 ? true : $(this).attr('data-filter').includes(filterType);
      })
      .removeClass('listing__item--non-active');

    const hiddenElements = this.opts.listItems.filter('.listing__item--non-active').length;

    if (this.opts.showAllButton) {
      this.opts.showAllButton[`${hiddenElements >= 1 ? 'remove' : 'add'}Class`]('filter-button__show-all-hidden');
    }
  }
};

Filter.fn.setup = function () {
  this.setEvents();
  if (this.opts.controlMargin) {
    this.opts.listItems.filter(':visible').filter(':odd').css('margin-right', 0);
  }
};

$.fn.filterItems = function (obj) {
  return (new Filter()).init($(this), obj);
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/plugins/filterItems.js